<script setup lang="ts">
import { Props, Emit, setup } from './colorBallCell.setup';

const props = defineProps<Props>();
const emit = defineEmits<Emit>();

const { filteredCells, baseGridBallsEle, moreCnt, clickCell, getContainersColorBall } = setup(
  props,
  emit,
);
</script>
<template>
  <div
    ref="baseGridBallsEle"
    class="base-grid__containers--wrapper"
    @click="($event) => clickCell(fieldName, cells, row, $event)"
  >
    <span
      v-for="(status, idx) in filteredCells"
      :key="idx"
      class="base-grid__containers--wrapper containers-status"
      :class="getContainersColorBall(status)"
    />

    <span
      v-if="moreCnt > 0"
      class="base-grid__containers--wrapper containers-count"
    >
      + {{ moreCnt }}
    </span>
  </div>
</template>

<style lang="scss">
.base-grid__containers--wrapper {
  display: flex;
  gap: 5px;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;

  .containers-status {
    width: 12px;
    height: 12px;
    padding: 0 6px;
    border-radius: 50%;

    &.pending {
      background-color: var(--containers-status-pending-bg-color);
    }
    &.running {
      background-color: var(--containers-status-running-bg-color);
    }
    &.failed {
      background-color: var(--containers-status-failed-bg-color);
    }
    &.unknown {
      background-color: var(--containers-status-unknown-bg-color);
    }
  }

  .containers-count {
    width: 31px;
    height: 16px;
    padding: 0 8px;
    cursor: pointer;
    user-select: none !important;
    border-radius: 29px;
    background-color: var(--badge-bg-color);
    font-size: 11px;
    line-height: 16px;
    color: var(--main-font-color);
  }
}
</style>
